var NOTIFICATION_CONSTANTS = {
    TO_EMAIL_US: "webform@paypal.com",
    SUBJECT_US: "GivingFund C840",

    TO_EMAIL_UK: "webform@paypal.co.uk",
    SUBJECT_UK: "GivingFund C826",

    TO_EMAIL_CA: "care@paypal-givingfund.ca",
    SUBJECT_CA: "GivingFund C124",

    TO_EMAIL_CA_FR: "care@paypalgivingfund.com.fr",
    SUBJECT_CA_FR: "GivingFund C124",

    TO_EMAIL_AU: "webform@paypal.com",
    SUBJECT_AU: "GivingFund C036",

    FROM: "PPGF_Care",
    TO: "Webform"
},
    NAME_CONSTANTS = {
        namePrefix: 'PREFIX',
        givenName: 'FIRSTNAME',
        middleName: 'MIDDLENAME',
        surname: 'LASTNAME',
        nameSuffix: 'SUFFIX',
        altName: 'ALT_NAME'
    },
    DATE_CONSTANTS = {
        US: {
            PAYOUT_DATE: '25',
        },
        CA: {
            PAYOUT_DATE: '30',
        }
    },
    CURRENCY_CONSTANTS = {
        US: {
            RAISED_PER_MINUTE_NUMBER: '164',
            RAISED_PER_MINUTE: '164',
            RAISED_PER_YEAR: '86.6',
            SMALLNONPROFIT: '5000',
            EXAMPLE_DONATION: '100',
            GFM_PLATFORM_FEE: '5',
            GFM_PROCESS_FEE: '0.7',
            PP_PROCCESS_PERC: '2.2',
            PP_PROCCESS_PLUS: '0.3',
            PP_PROCESS_TOTAL: '2.5',
            PPGF_FEE: '0',
            NET_FUND_CHARITY: '91.8',
            HOLIDAY_OFFER: '1',
            TOTAL_HOLIDAY_OFFER: '101'
        },
        GB: {
            RAISED_PER_MINUTE_NUMBER: '37',
            RAISED_PER_MINUTE: '37',
            RAISED_PER_YEAR: '19',
            SMALLNONPROFIT: '5000'
        }
    },
    PAGE_CONSTANTS = {
        INTIAL_PAGE_NO: "1",
        PAGE_SIZE_TEN: "10",
        PPGF_ACC_CLOSED: "Closed",
        PPGF_ACC_CONFIRMED: "confirmed",
        PAGES: {
            DASHBOARD: "dashboard",
            CLOSED_ACC: "closed-acc",
            NOT_CONFIRMED: "not-confirmed"
        },
        AMOUNT_SIGN: {
            PLUS: "pos",
            MINUS: "neg"
        },
        NONPROFIT_MCCCODE: 8398
    },
    ERR_CONSTANTS = {
        desc: 'descError',
        missionArea: 'missionAreaError',
        phone: 'phoneError',
        keywords: 'keywordsError',
        cta: 'ctaError',
        email: 'emailError',
        email2: 'email2Error',
        firstName: 'firstNameError',
        lastName: 'lastNameError'
    },
    ALLOWED_PPGF_COUNTRY_LIST = ['US', 'GB', 'CA', 'AU'],
    DIRECTMODEL_COUNTRIES = ['BR', 'DE', 'ES', 'FR', 'IT', 'MX', 'NL', 'PL', 'PT'],
    ROUTE_PATH = {
        HOME_PAGE: ['/', '/home'],
        OBS_URL: ['/preEnroll'],
        TERMS_CONDITIONS: ['/termsandconditions'],
        POLICIES: ['/policies', '/donation-delivery', '/donation-refunds', '/user-agreement', '/privacy', '/nonprofit-certification', '/non-profits', '/item-cancellation'],
        ENROLL: ['/enrollInPPGF', '/transferCode', '/enroll'],
        HELP_REDIRECTS: ['/charity', '/donors', '/faq'],
        ABOUT_REDIRECT: ['/about'],
        CONTACT_REDIRECT: ['/contact', '/contact-confirmation'],
    },
    ENROLL_CHAR_COUNT = {
        DESCRIPTION: 400,
        KEYWORDS: 200,
        SLOGAN: 90
    }

module.exports = {
    NOTIFICATION_CONSTANTS: NOTIFICATION_CONSTANTS,
    NAME_CONSTANTS: NAME_CONSTANTS,
    DATE_CONSTANTS: DATE_CONSTANTS,
    CURRENCY_CONSTANTS: CURRENCY_CONSTANTS,
    PAGE_CONSTANTS: PAGE_CONSTANTS,
    ERR_CONSTANTS: ERR_CONSTANTS,
    ALLOWED_PPGF_COUNTRY_LIST: ALLOWED_PPGF_COUNTRY_LIST,
    DIRECTMODEL_COUNTRIES: DIRECTMODEL_COUNTRIES,
    ROUTE_PATH: ROUTE_PATH,
    ENROLL_CHAR_COUNT: ENROLL_CHAR_COUNT
};


// WEBPACK FOOTER //
// /causemisspiggynodeweb-ci-9188/workspace/Release/constants/constants.js